module.exports = __webpack_public_path__ + "static/img/references2.fcde34a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/references2.jpg
// module id = J5DV
// module chunks = 1